import z from 'zod';
import {questionStatusSchema} from '../question/QuestionStatus';

/**
 * Job input for BULK_CHANGE_QUESTION_STATUS.
 * Used as the `data` payload (JSON string) when creating a bulk change question status job.
 */
export const bulkChangeQuestionStatusJobDataSchema = z.object({
  moduleId: z.string().min(1, 'Module ID is required'),
  filterStatus: questionStatusSchema,
  changeStatus: questionStatusSchema,
});

export interface BulkChangeQuestionStatusJobData extends z.infer<typeof bulkChangeQuestionStatusJobDataSchema> {}
